// no-change.ts
var NO_CHANGE = Symbol("URL_SEARCH_PARAMS_NO_CHANGE");
export {
  NO_CHANGE
};
